/*!
 * jQuery Auto Increment End Time plugin
 * Original author: Nimrod Evans @shraka
 * For: reinteractive.com
 * Updated: 2020-02-21
 * Licensed under the MIT license
 *
 * Automatically pulls a 24 hour time string from a
 * HTML5 input.time field, increments it, and inserts
 * the result into another input.time field
 *
 * Note: This plugin doesn't try to advance a day field when crossing over midnight
 */

export default (function ($, window, document, undefined) {
  'use strict'

  $.fn.autoIncrementEndTime = function(opts = {}) {
    const target = $(this).attr('data-js-target');

    // Add leading zero to int under 10
    function addLeadingZero(int) {
      return (int <= 9) ? '0' + int: int;
    }

    if (typeof opts.increment === 'undefined') {
      if ($('this').attr('data-js-increment')) {
        opts.increment = $('this').attr('data-js-increment');
      } else {
        opts.increment = 60;
      }
    }

    // Add touched function to target
    $(target).on('change', function () {
      $(this).addClass('touched');
    });

    // Add end time advance feature
    $(this).on('change', function () {
      // Only take action if the end time hasn't been touched
      if (!$(target).hasClass('touched')) {
        let hour;
        let min;

        [hour, min] = $(this).val().split(':');
        hour = parseInt(hour);
        min = parseInt(min);

        // Advance time
        min += opts.increment;

        // Check if minutes are within limts
        if (min >= 60) {
          hour = hour + 1;
          min = min - 60;
          hour -= (hour >= 24)? 24: 0;
        }
        hour = addLeadingZero(hour);
        min = addLeadingZero(min);

        // Set the end time
        $(target).val(`${hour}:${min}`);
      }
    });
  }
})(jQuery, window, document);
